import React, { useEffect, useState } from "react";
import { postCrearOtrosParticipantes, postModalOtrosParticipantes, postProcedimientoModificar } from "../../../services/PaginaRuta";
import ModalAgregarListaSeleccionMedicoEspecialidadOtroParticipantes from "./ModalAgregarListaSeleccionMedicoEspecialidadOtroParticipantes";
import ModalOtrosParticipantesAgregarListaSeleccionMedico from "./ModalOtrosParticipantesAgregarListaSeleccionMedico";
import ModalOtrosParticipantesRepetido from "./ModalOtrosParticipantesRepetido";
import ModalSeleccionHonorarios from "./ModalSeleccionHonorarios";
 

const ModalOtrosParticipantesCirugia = ({setModalOnOtrosParticipantes, idCirugia, passActualizarTablaProcedimiento}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataOtrosParticipantes, setDataOtrosParticipantes] = useState([])
  const [modalOnSeleccionHororarios, setmodalOnSeleccionHororarios] = useState(false)
  const [modalOnAgregarMedicoOtrosParticipantes, setmodalOnAgregarMedicoOtrosParticipantes]=useState(false)
  const [modalOnMedicoEspecialidadAgregar, setmodalOnMedicoEspecialidadAgregar]=useState(false)
  const [dataUser, setDataUser] = useState([])
  const [errorMedico, seterrorMedico]=useState('')
  const [errorEspecialidad, seterrorEspecialidad]=useState('')
  const [errorHonorario, seterrorHonorario]=useState('')
  const [modalOnValidarMedicoRepetido, setmodalOnValidarMedicoRepetido]=useState(false)

  const [dataChildAgregarHonorario, setdataChildAgregarHonorario]=useState({
    codigoHonorario:'',
    descripcionHonorario:''
  })

  const [dataChildOtrosAgregarMedico, setdataChilddOtrosAgregarMedico]=useState({
    codigoMedico:'',
    nombreMedico:'',
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })

  const [dataChildOtrosAgregarEspecialidad, setdataChildOtrosAgregarEspecialidad]=useState({
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })

  const hanldeOnsumitAgregarOtrosParticipantes=(e)=>{
    e.preventDefault();
    const body={
      ProEmpCod:usuarioInfo.Empresa,
      ProMCDpto:usuarioInfo.Sede,
      ProCirCod: e.target.numeroCirugia.value,
      PersCod: e.target.codigoMedico.value,
      PersTip: e.target.codigoTipo.value,
      PersEsp: e.target.codigoEspecialidad.value,
      PersEst:'',

    }
    //console.log(body,'creas otros participantes')
    if(errorMedico == '' && errorEspecialidad=='' && errorHonorario==''){
      postCrearOtrosParticipantes(body).then((res)=>{
        //console.log(res.data.error,'crear otros participantes')
        if(res.data.error){
          setmodalOnValidarMedicoRepetido(true)
        }else{
        passActualizarTablaProcedimiento(body)
        setModalOnOtrosParticipantes(false)
      }
      }).catch((error) => {
        //console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true);
        //setLoading(true);
      });

    }
    
    
  }

  const passChildOtrosAgregarEspecialidad=(data)=>{
    setdataChildOtrosAgregarEspecialidad(data)
    setdataChilddOtrosAgregarMedico({
      codigoMedico:dataChildOtrosAgregarMedico.codigoMedico,
      nombreMedico:dataChildOtrosAgregarMedico.nombreMedico,
      codigoEspecialidad:data.codigoEspecialidad,
      nombreEspecialidad:data.nombreEspecialidad
    })
    //console.log(data,'otros participananantes especialidad')
    seterrorEspecialidad('')
  }

  const passChildOtrosAgregarMedico=(data)=>{
    //console.log(data,'otros participananantes medico')
    setdataChilddOtrosAgregarMedico(data)
    // setdataChildOtrosAgregarEspecialidad({
    //   codigoEspecialidad:'',
    //   nombreEspecialidad:''
    // })
    seterrorMedico('')
    seterrorEspecialidad('')
  }

  const passAgregarHonorario=(data)=>{
    //console.log(data,'otros participananantes')
    setdataChildAgregarHonorario(data)
    seterrorHonorario('')
  }

  const handleOnclickMedicoEspecialidad=()=>{
    setmodalOnMedicoEspecialidadAgregar(true)
  }

  const handleOnclickAgregarMedicoOtrosParticipantes=()=>{
    setmodalOnAgregarMedicoOtrosParticipantes(true)
    
  }

  const handleCancelarClick=()=>{
    setModalOnOtrosParticipantes(false)
  }

  const handleOnclickSeleccionHonorarios = ()=>{
    setmodalOnSeleccionHororarios(true)
  }

  useEffect(()=>{
    //console.log(idCirugia, "idCirugia")
    seterrorMedico('Seleccionar un Médico')
    seterrorEspecialidad('Seleccionar una Especialidad')
    seterrorHonorario('Seleccionar un Honorario')
    const body = {
      varProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: idCirugia,
    }
    postModalOtrosParticipantes(body).then((res)=>{//corregir
      setDataOtrosParticipantes(res.data[0])
      //console.log(res.data,"otros participantes")
    })

    const bodyDatosUser = {
      vaProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: idCirugia,
    };

    postProcedimientoModificar(bodyDatosUser).then((res)=>{
      setDataUser(res.data[0])
      //console.log(res.data,"datos usuario")
    })
  },[])
  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)]   mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Otros Participantes Cirugía-
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative p-4">
            <form onSubmit={hanldeOnsumitAgregarOtrosParticipantes}>
              <div >
                
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        N° Cirugía
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.ProCirCod}
                        name='numeroCirugia'
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-4 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Numero Documento 
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Tipo de Documento
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.MPTDoc}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Nombre del Paciente
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={dataUser.MPNOMC}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                
                <h5
                  className="text-xl font-medium leading-normal text-gray-800 text-center pt-3"
                  id="exampleModalScrollableLabel"
                >
                  Otros Participantes
                </h5>
                <div className="flex py-2 text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Código
                    </label>
                    <input
                      onFocus={handleOnclickAgregarMedicoOtrosParticipantes}
                      defaultValue={dataChildOtrosAgregarMedico.codigoMedico}
                      name='codigoMedico'
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorMedico}
                    </label>
                  </div>
                  <div className="w-2/3  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Nombre
                    </label>
                    <input
                      defaultValue={dataChildOtrosAgregarMedico.nombreMedico}
                      autoComplete="off"
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Especialidad
                    </label>
                    <input
                      onFocus={handleOnclickMedicoEspecialidad}
                      defaultValue={dataChildOtrosAgregarMedico.codigoEspecialidad}
                      name='codigoEspecialidad'
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorEspecialidad}
                    </label>
                  </div>
                  <div className="w-2/3  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Nombre
                    </label>
                    <input
                      defaultValue={dataChildOtrosAgregarMedico.nombreEspecialidad}
                      disabled={true}
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo 
                    </label>
                    <input
                      onFocus={handleOnclickSeleccionHonorarios}
                      defaultValue={dataChildAgregarHonorario.codigoHonorario}
                      name='codigoTipo'
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorHonorario}
                    </label>
                  </div>
                  <div className="w-2/3  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Tipo de Honorario
                    </label>
                    <input
                      defaultValue={dataChildAgregarHonorario.descripcionHonorario}
                      autoComplete="off"
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button type="submit"
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                  Guardar
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
      {modalOnSeleccionHororarios? <ModalSeleccionHonorarios setmodalOnSeleccionHororarios={setmodalOnSeleccionHororarios} passAgregarHonorario={passAgregarHonorario}/>:null}
      {modalOnAgregarMedicoOtrosParticipantes? <ModalOtrosParticipantesAgregarListaSeleccionMedico setmodalOnAgregarMedicoOtrosParticipantes={setmodalOnAgregarMedicoOtrosParticipantes} passChildOtrosAgregarMedico={passChildOtrosAgregarMedico} />:null}
      {modalOnMedicoEspecialidadAgregar? <ModalAgregarListaSeleccionMedicoEspecialidadOtroParticipantes setmodalOnMedicoEspecialidadAgregar={setmodalOnMedicoEspecialidadAgregar} dataChildOtrosAgregarMedico={dataChildOtrosAgregarMedico.codigoMedico} passChildOtrosAgregarEspecialidad={passChildOtrosAgregarEspecialidad}/>:null}
      {modalOnValidarMedicoRepetido? <ModalOtrosParticipantesRepetido setmodalOnValidarMedicoRepetido={setmodalOnValidarMedicoRepetido}/>:null}
    </>
  );
};

export default ModalOtrosParticipantesCirugia;
